var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAndroidFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.601 18.176C30.269 17.2101 30.269 14.7924 28.601 13.825L24.2677 11.3138L19.1077 16.0005L24.2661 20.6871L28.5994 18.176H28.601ZM22.8185 21.5263L17.9222 17.0771L7.38175 26.6563C7.70506 28.2856 9.5693 29.2055 11.0861 28.3267L22.8185 21.5263ZM7.3335 24.5441V7.45522L16.7368 16.0005L7.3335 24.5441ZM7.38175 5.34463L17.9222 14.9238L22.8185 10.4746L11.0861 3.67422C9.5693 2.79388 7.70506 3.7138 7.38175 5.34463Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidFill);
export default __webpack_public_path__ + "static/media/android_fill.082be4da249b9267976ecc0a9a604b17.svg";
export { ForwardRef as ReactComponent };